var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('My groups & buddies'),expression:"'My groups & buddies'"}],staticClass:"groups",on:{"click":_vm.onClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups-icon"},[_c('i',{staticClass:"fa-solid fa-people-group"})])
}]

export { render, staticRenderFns }